/*
 * Copyright (c) 2021.
 * This file is part of the Compo B2B application.
 * (c) Compo soft - Ganturin Vladimir <gun2rin@gmail.com>
 * For the full copyright and license information, please view the LICENSE
 * file that was distributed with this source code.
 */

import {inject, Injectable} from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import {CompoApiService} from 'compob2b-libs';
import {map} from 'rxjs/operators';
import {Observable} from 'rxjs';
import {DEFAULT_MENU_ACCESS_URL_NORMALIZER, MENU_ACCESS_URL_NORMALIZER} from './app-routing.tokens';

@Injectable({
  providedIn: 'root'
})
export class AuthGuardMenuService  {
  /** URL в форме `menu.uri` задаёт приложение — см. `app-routing.tokens.ts`. */
  private readonly normalizeUrl =
    inject(MENU_ACCESS_URL_NORMALIZER, {optional: true}) ?? DEFAULT_MENU_ACCESS_URL_NORMALIZER;

  constructor(private readonly api: CompoApiService
  ) {
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    return this.checkMenu(state.url);
  }

  private checkMenu(url: string): Observable<boolean> {
    return this.api.post<string, boolean>('/ch', this.normalizeUrl(url)).pipe(map(response => response.data));
  }
}
